import { TiendaRepository } from '../../domain/repositories/tienda.repository';
import { tiendaRepository } from '../repositories/tienda.respository';

export const tiendaRepositoryInstance: TiendaRepository = tiendaRepository();
